import styled from 'styled-components/native'

export const HotspotsWrapper = styled.View`
  height: 100%;
  width: 100%;
`
